module.exports = __webpack_public_path__ + "img/jyty.a443d27f.png";